import { Modal } from 'antd';
import React, { FC } from 'react';

import { TitleModal } from '../../../components/TitleModal';
import { FormOrder } from '../FormOrder';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onGetOrders: () => void;
};

export const ModalCreateOrder: FC<Props> = ({
  isOpen,
  onClose,
  onGetOrders,
}) => {
  return (
    <Modal
      width={600}
      destroyOnClose
      footer={null}
      onCancel={onClose}
      title={<TitleModal>Создание заявки</TitleModal>}
      open={isOpen}
    >
      <FormOrder isOpen={isOpen} onClose={onClose} onGetOrders={onGetOrders} />
    </Modal>
  );
};
